import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PieChart from '../common/Charts/PieChart';
import BarChart from '../common/Charts/BarChart';
import {
  processData,
  checkAsterickFormate,
} from '../../util/QuickReportsUtils';
import { MODULE_DEMOGRAPHIC_PROFILE } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

const filterValue = (label, value) => {
  if (
    label === 'Married' &&
    Math.round(Number(value.pct.replace(/%/g, ''))) === 0
  ) {
    return 'NA';
  }
  return value.pct || value.other;
};

const renderGeneralTable = data => (
  <table className="general-stats-table">
    <tbody>
      {data.map(({ label, value }) => (
        <tr key={uuid()}>
          <td title={`${label}`}>
            <span className="bullet" role="img">
              <span role="img" aria-label="E1">&#9899;</span>
              <span role="img" aria-label="E2">&nbsp;</span>
            </span>
            {label}
          </td>
          <td title={`${filterValue(label, value)}`}>
            {filterValue(label, value)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default class DemographicProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { showSingleAsterisk: false, showDoubleAsterisk: false };
  }

  componentDidMount() {
    this.props.handletitle('Demographic Profile');
    this.props.handleExportParams();
    this.props.trackerFn({ subModule: MODULE_DEMOGRAPHIC_PROFILE });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps() {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  render() {
    return (
      <div className="quick-report-graph-wrapper" style={{ border: 'none' }}>
        <div className="large-12 clearfix">
          <div className="column medium-4 large-4 padding-0">
            <div className="card quick-report-cards">
              <h4 className="report-chart-title">General Statistics</h4>
              {renderGeneralTable(this.props.data.General)}
            </div>
          </div>
          <div className="column medium-4 large-4 padding-0">
            <div
              className="card quick-report-cards"
              style={{ overflow: 'hidden' }}
            >
              <h4 className="report-chart-title">Education</h4>
              <BarChart
                chartTitle=""
                chartColor={chartColor}
                barChartHeight={230}
                yLabel="{value} %"
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data.Education },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabels
                dataLabelFormat={checkAsterickFormate(
                  '{y}',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
              />
            </div>
          </div>
          <div className="column medium-4 large-4 padding-0">
            <div
              className="card quick-report-cards"
              style={{ marginRight: 0, overflow: 'hidden' }}
            >
              <h4 className="report-chart-title">Ethnicity</h4>
              <PieChart
                chartTitle=""
                pieChartHeight={230}
                chartColor={['#247BA0', '#F25F5C']}
                chartLegend={{
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                  x: 0,
                  y: 0,
                }}
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data.Ethnicity },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabelFormat={checkAsterickFormate(
                  '{y}%',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
              />
            </div>
          </div>
        </div>
        <div className="large-12 clearfix">
          <div className="column medium-4 large-4 padding-0">
            <div
              className="card quick-report-cards"
              style={{ overflow: 'hidden' }}
            >
              <h4 className="report-chart-title">Race</h4>
              <PieChart
                chartTitle=""
                pieChartHeight={230}
                donutSize="70%"
                chartColor={chartColor}
                dataLabelDistance={30}
                dataLabelColor="rgb(48, 67, 93)"
                chartLegend={{
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                  x: 0,
                  y: 0,
                }}
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data.Race },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabelFormat={checkAsterickFormate(
                  '{y}%',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
              />
            </div>
          </div>
          <div className="column medium-8 large-8 padding-0">
            <div className="card quick-report-cards" style={{ marginRight: 0 }}>
              <h4 className="report-chart-title">Household Income</h4>
              <BarChart
                chartTitle=""
                barChartHeight={230}
                chartType="bar"
                chartColor={chartColor}
                yLabel="{value} %"
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data['HH Income'] },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabelFormat={checkAsterickFormate(
                  '{y}',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
                dataLabels
              />
            </div>
          </div>
        </div>
        <div className="large-12 clearfix">
          <div className="column medium-8 large-8 padding-0">
            <div className="card quick-report-cards">
              <h4 className="report-chart-title">Age</h4>
              <BarChart
                chartTitle=""
                barChartHeight={200}
                chartColor={chartColor}
                yLabel="{value} %"
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data.Age },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabels
                dataLabelFormat={checkAsterickFormate(
                  '{y}',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
              />
            </div>
          </div>
          <div className="column medium-4 large-4 padding-0">
            <div
              className="card quick-report-cards"
              style={{ marginRight: 0, overflow: 'hidden' }}
            >
              <h4 className="report-chart-title">Gender</h4>
              <PieChart
                chartTitle=""
                pieChartHeight={200}
                chartColor={['#247BA0', '#F25F5C']}
                chartLegend={{
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                  x: 0,
                  y: 0,
                }}
                data={{
                  tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                  processedData: processData(
                    { rawData: this.props.data.Gender },
                    this.updateAsteriskStatus,
                    this.props.study
                  ),
                }}
                dataLabelFormat={checkAsterickFormate(
                  '{y}%',
                  this.state.showDoubleAsterisk,
                  this.state.showSingleAsterisk
                )}
              />
            </div>
          </div>
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

DemographicProfile.propTypes = {
  data: PropTypes.shape({
    'HH Income': PropTypes.arrayOf(PropTypes.shape({})),
    Education: PropTypes.arrayOf(PropTypes.shape({})),
    Ethnicity: PropTypes.arrayOf(PropTypes.shape({})),
    Race: PropTypes.arrayOf(PropTypes.shape({})),
    General: PropTypes.arrayOf(PropTypes.shape({})),
    Gender: PropTypes.arrayOf(PropTypes.shape({})),
    Age: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
